import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);

export default new Vuex.Store({
    state: {        
        searchData: {
            isSearchResult: false,
            isSearchLoader: false,           
            data: null
        },
        newsData: {
            isNewsDetails: false,
            isNewsLoader: false,           
            data: null
        },

         UniversityAppData: {
            universityApp: false,
        },
               
         categoryTypeData: {
            categoryType: null,
        }
    },

    getters: {
         getSearchData(state) {
            return state.searchData
        },
    
         getNewsData(state) {
            return state.newsData
        },

        getUniversityAppData(state) {
            return state.UniversityAppData
        },
        
        getCategoryTypeData(state) {
            return state.categoryTypeData
        },
    },

    mutations: {
        setSearchData(state, data) {
            state.searchData = data
        },

        setNewsData(state, data) {
            state.newsData = data
        },
         setCategoryTypeData(state, data) {
             state.categoryTypeData = data
             
        },
       
    },

    actions: {
        changeCounterAction({
            commit
        }, data) {
            commit("changeTheCounter", data);
        }
    }
});
